export default "__VITE_PUBLIC_ASSET__a08d4755__"